import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JPMAM_DESTINATION_BASE_PATH } from '../../../../../../../../../features/vendor/jpmam/destination/jpmam-destination-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jpmam-destination-list',
        label: 'J.P. Morgan',
        to: JPMAM_DESTINATION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
